import React from "react";
import { ClipboardListIcon, CompassIcon, NetworkIcon, RefreshCwIcon, SearchCheckIcon, TimerIcon, BoxIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { painPoints, PainIcon } from "../data/content";
const iconMap: Record<PainIcon, BoxIcon> = {
  start: CompassIcon,
  time: TimerIcon,
  connect: NetworkIcon,
  scattered: ClipboardListIcon,
  review: SearchCheckIcon,
  rebuild: RefreshCwIcon
};
export function PainPoints() {
  return <section className="bg-navy px-4 py-16 sm:py-24" aria-labelledby="pain-title" data-id="element-273" data-mp="220e8yyf77ebp">
      <div className="mx-auto max-w-5xl" data-id="element-274" data-mp="1o03froqf1nnd">
        <div id="pain-title" data-id="element-275" data-mp="1o14wa8q7b2ch">
          <SectionHeading tone="dark" title={<>Does Any of This Sound <span className="italic text-gold-light" data-id="element-277" data-mp="1sz6n5ftvc5yi">Familiar?</span></>} intro="If you answer YES to even one of these, I created this system with professionals like you in mind." data-id="element-276" data-mp="1syn41vshfbiw" />
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-278" data-mp="3nbd1gni272v1">
          {painPoints.map(p => {
          const Icon = iconMap[p.icon];
          return <li key={p.title} className="flex gap-4 rounded-2xl bg-navy-light p-5 ring-1 ring-white/10" data-id="element-279" data-mp="1yyc1bnig66qk">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gold/15 text-gold-light" data-id="element-280" data-mp="27sz1o5997svy">
                  <Icon aria-hidden="true" className="h-6 w-6" data-id="element-281" data-mp="23r54i6y9p70j" />
                </span>
                <div data-id="element-282" data-mp="1g1atluxidsix">
                  <h3 className="font-serif text-lg font-bold leading-snug text-white" data-id="element-283" data-mp="1g2u93jbcbzjn">{p.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-white/75" data-id="element-284" data-mp="1b3rfqw4q3hri">{p.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-gold/40 bg-navy-light p-6 text-center" data-id="element-285" data-mp="1k3e68mvwz35s">
          <p className="font-serif text-2xl font-bold text-gold-light" data-id="element-286" data-mp="30he7c16hwyum">And it shouldn’t have to feel this difficult.</p>
          <p className="mt-3 text-[16px] leading-relaxed text-white/85" data-id="element-287" data-mp="2vjconhczf1jo">
            The problem isn’t always a lack of knowledge. Sometimes, it’s the lack of a structured way to organize and connect
            that knowledge when working through a complex case.
          </p>
        </div>

        <div className="mt-10 [&_p]:text-white/70" data-id="element-288" data-mp="225lbhae79qxn">
          <CtaButton label="I Want a Structured System for My Cases" data-id="element-289" data-mp="223qnfn7mtipc" />
        </div>
      </div>
    </section>;
}